import { useContext } from 'react';
import { AuthContext } from '@/contexts';

/** Access the current auth state. Must be used within an `AuthProvider`. */
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
